export class ProductionTaskRow {
  constructor(
    public machineName?: string,
    public machineReference?: number,
    public ofCode?: string,
    public ofHash?: string,
    public articleNumber?: string,
    public operationCode?: string,
    public quantity?: number,
    public startDate?: number,
    public endDate?: number,
    public running?: boolean,
    public blocked?: boolean,
    public urgent?: boolean,
    public claimed?: boolean,
    public pendingPreparation?: boolean,
    public taskVersionHash?: string,
    public machineHash?: string,
    public compatibleMachineHashes?: string[],
    public programDefinition?: string,
    public pendingProgramDefinition?: boolean,
    public mpReady?: string,
    public materialReady?: boolean,
    public materialInStock?: boolean
  ) { }
}

export class ProductionMachine {
  constructor(
    public machineName?: string,
    public machineReference?: number,
    public machineHash?: string
  ) { }
}

export class ProductionPlanResponse {
  constructor(
    public rows?: ProductionTaskRow[],
    public totalTasks?: number,
    public machineCount?: number,
    public urgentCount?: number,
    public machines?: ProductionMachine[]
  ) { }
}

export class ProductionMoveRequest {
  constructor(
    public taskVersionHash?: string,
    public targetMachineHash?: string,
    public targetStartTime?: number,
    public reason?: string,
    public emergencyOverride?: boolean
  ) { }
}

export class ProductionMoveResponse {
  constructor(
    public previousVersionId?: number,
    public newVersionId?: number,
    public actionId?: string,
    public newMachineId?: number,
    public newStartTime?: number,
    public newEndTime?: number
  ) { }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/production-plan.ts